import outlets from './outlets';
import cities from './cities';
import legalEntities from './legalEntities';

export default [outlets, cities, legalEntities];
